export default __webpack_public_path__ + "static/media/7.fc0e6588.png";